import { formatTimestamp } from 'utils/calculateTime';
import { NoShowToolTipProps } from 'models/Common/buttonTypes';
import styled from 'styled-components';
import { BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { zIndex } from 'styles/Global/globalStyles';
import { Radius } from 'styles/Global/objectStyles';
import { Body5Medium, Caption2Medium } from 'styles/Global/typography';

const NoShowToolTip = ({ diagnosisInfo, $top, $left }: NoShowToolTipProps) => {
    return (
        <Layout $top={$top} $left={$left}>
            {diagnosisInfo.noShowInfo?.map((item, idx) => {
                return (
                    <>
                        <div>
                            노쇼 {idx + 1}회 ({<DateWrapper>{formatTimestamp(item.noShowTimestamp!)}</DateWrapper>})
                        </div>
                        <InnerLayout>{item.noShowReason || '-'}</InnerLayout>
                    </>
                );
            })}
        </Layout>
    );
};

export default NoShowToolTip;

const Layout = styled(Caption2Medium)<{ $top?: string; $left?: string }>`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 220px;
    background-color: ${BackgroundColor.color_background_white};
    border: 1px solid ${BorderColor.color_border_over};
    padding: 12px;
    border-radius: ${Radius.radius_8};
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    line-height: normal;
    top: ${(props) => props.$top || '26px'};
    left: ${(props) => props.$left || '0px'};
    color: ${TextColor.color_text_light};
    gap: 6px;
    z-index: ${zIndex.floating};
    pointer-events: none;
`;

const InnerLayout = styled(Body5Medium)`
    flex-direction: column;
    width: 100%;
    padding: 8px 10px;
    background-color: ${BackgroundColor.color_background_neutral};
    border-radius: ${Radius.radius_4};
    text-align: left;

    white-space: pre-wrap; /* CSS3 */
    white-space: -moz-pre-wrap; /* Firefox */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* IE & modern browsers */
    overflow-wrap: break-word; /* CSS3 명세 */
    word-break: break-word; /* 단어 단위 줄바꿈 */
`;

const DateWrapper = styled.span`
    text-decoration: line-through;
    -webkit-text-decoration: line-through;
    text-decoration-line: line-through;
    text-decoration-style: solid;
`;
